import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/css/main.css'
import { currency } from './commons/currency'
import { display_date, order_status, order_status_color, order_status_text_color, vip_level, vip_level_color, capitalize, display_value, display_color, display_text_color, pad } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
import VueMuuriGrid from 'vue-muuri-grid'
import HighchartsVue from 'highcharts-vue'
import firebase from 'firebase';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import VueExcelEditor from 'vue-excel-editor';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

var VueDragula = require('vue-dragula');

try {
  const firebaseConfig = {
    apiKey: 'AIzaSyAN2aQz5h9C_dGKNXkwYXx2xKmt4ON5FCM',
    authDomain: 'oee-app-cc5a1.firebaseapp.com',
    databaseURL: 'https://oee-app-cc5a1.firebaseio.com',
    projectId: 'oee-app-cc5a1',
    storageBucket: 'oee-app-cc5a1.appspot.com',
    messagingSenderId: '579480956217',
    appId: '1:579480956217:web:0e10030639ec0ab80ccce8',
    measurementId: 'G-54ZGV0VRV2'
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const messaging = firebase.messaging();
  
  messaging.usePublicVapidKey('BOgNf9bFELoQEYzUCJb-l6kH6VnQGO8kS0LfjVBCnFYPczmT-ghhn5R64dB_d9gXNqKHhXHvoipHwshTITHqoJg'); // 1. Generate a new key pair
  // Request Permission of Notifications
  messaging.requestPermission().then(() => {
    // console.log('Notification permission granted.');
    // Get Token
    messaging.getToken().then((token) => {
      window.localStorage.setItem('FCM_Token', JSON.stringify(token));
    })
  }).catch();
  messaging.onMessage((payload) => {
    // console.log('onMessage: ', payload);
  }); 
} catch (error) {
  // expected output: ReferenceError: nonExistentFunction is not defined
  // Note - error messages will vary depending on browser
}

Vue.use(VueResource);
Vue.use(require('vue-shortkey'))
Vue.use(VueMuuriGrid);
Vue.use(HighchartsVue);
Vue.use(VueCtkDateTimePicker);
Vue.use(VueDragula);
Vue.use(VueExcelEditor);
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('order_status', order_status)
Vue.filter('order_status_color', order_status_color)
Vue.filter('order_status_text_color', order_status_text_color)
Vue.filter('vip_level', vip_level)
Vue.filter('vip_level_color', vip_level_color)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)
Vue.filter('pad', pad)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
